var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "product__category" }, [
      _c("li", { staticClass: "active" }, [_vm._v("全て")]),
      _vm._v(" "),
      _c("li", [_vm._v("カテゴリ")]),
      _vm._v(" "),
      _c("li", [_vm._v("カテゴリ")]),
      _vm._v(" "),
      _c("li", [_vm._v("カテゴリ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }